import { Box, Typography, LinearProgress, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";

// Estilizando o componente LinearProgress para uma aparência mais moderna
const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: theme.palette.grey[200],
  '& .MuiLinearProgress-bar': {
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
}));

// Estilizando o container do item para hover effects
const CategoryItemBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  marginBottom: theme.spacing(1),
}));

export default function SoldCategoryItem({ category, maxRevenue }) {
  // Calcular a porcentagem com base no item com maior receita
  const percentage = maxRevenue ? Math.round((category.receita / maxRevenue) * 100) : 0;
  
  // Formatar valores para exibição
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('pt-BR').format(value);
  };

  return (
    <CategoryItemBox>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5, alignItems: 'center' }}>
        <Typography variant="body2" fontWeight="500" sx={{ flex: 1 }}>
          {category.nome}
        </Typography>
        <Tooltip title={`Vendas: ${formatNumber(category.totalVendas)} | Receita: ${formatCurrency(category.receita)}`}>
          <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
            {formatNumber(category.totalVendas)} un.
          </Typography>
        </Tooltip>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <StyledLinearProgress variant="determinate" value={percentage} />
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ minWidth: '36px' }}>
          {percentage}%
        </Typography>
      </Box>
    </CategoryItemBox>
  );
}
